<template>
    <main class="auth_page">
        <header class="auth_header">
            <button type="button" aria-label="返回登录" @click="$router.back()"><van-icon name="arrow-left" /></button>
            <div><p>NEW SERVICE ACCOUNT</p><h1>注册售后账号</h1></div>
        </header>
        <section class="auth_card">
            <p class="intro">完成手机验证后，系统会自动创建账号并绑定当前微信。</p>
            <van-field v-model.trim="form.name" label="姓名" maxlength="20" clearable placeholder="请输入联系人姓名" />
            <van-field v-model.trim="form.phone" label="手机号" type="tel" maxlength="11" clearable placeholder="请输入手机号" />
            <van-field v-model.trim="form.code" label="验证码" type="digit" maxlength="4" clearable placeholder="请输入验证码">
                <template #button>
                    <button class="code_button" type="button" :disabled="countdown > 0 || sending" @click="sendCode">
                        {{ countdown > 0 ? `${countdown}s` : (sending ? '发送中' : '获取验证码') }}
                    </button>
                </template>
            </van-field>
            <van-field label="性别">
                <template #input>
                    <van-radio-group v-model="form.sex" direction="horizontal">
                        <van-radio name="male">男</van-radio>
                        <van-radio name="female">女</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <button class="primary_button" type="button" :disabled="submitting" @click="register">
                <van-loading v-if="submitting" size="18" color="#fff" />
                <span v-else>注册并绑定微信</span>
            </button>
            <div class="notice"><van-icon name="passed" /><span>注册成功后无需创建应用，即可提交和查询自己的售后工单。</span></div>
        </section>
    </main>
</template>

<script>
import until from '@/api/until.js'
import noLoginApi from '@/api/teaching_studio_no_login.js'
import toolApi from '@/api/teaching_studio_tool.js'
import { finishWechatAuth } from '@/utils/saleServiceAuth.js'

export default {
    name: 'Register',
    data() {
        return {
            salt: '',
            sending: false,
            submitting: false,
            countdown: 0,
            timer: null,
            form: { name: '', phone: '', code: '', sex: 'male' }
        }
    },
    computed: {
        appId() {
            return this.$root.app_id || until.getParameter('app_id') || 'wx0154d46e98975549'
        }
    },
    mounted() {
        document.title = '注册售后账号'
        this.getSalt()
    },
    beforeDestroy() {
        if (this.timer) clearInterval(this.timer)
    },
    methods: {
        computerCode() {
            let guid = until.getCookie('guid')
            if (!guid) {
                guid = until.guid()
                until.setCookie('guid', guid)
            }
            return guid.substring(0, 6)
        },
        async getSalt() {
            const res = await toolApi.ToolForm_saltGet({ computer_code: this.computerCode() })
            if (res && res.errcode === 0) this.salt = res.other
        },
        startCountdown() {
            this.countdown = 60
            this.timer = setInterval(() => {
                this.countdown -= 1
                if (this.countdown <= 0) {
                    clearInterval(this.timer)
                    this.timer = null
                }
            }, 1000)
        },
        async sendCode() {
            if (!/^1\d{10}$/.test(this.form.phone)) return this.$toast('请输入正确的手机号')
            if (!this.salt) await this.getSalt()
            this.sending = true
            const res = await noLoginApi.Api_nologinLoginPostSmsPost({
                app_id: this.appId,
                computer_code: this.computerCode(),
                salt: this.salt,
                phone_number: this.form.phone
            })
            this.sending = false
            if (res && res.errcode === 0) {
                this.$toast.success('验证码已发送')
                this.startCountdown()
            }
            await this.getSalt()
        },
        async register() {
            if (!this.form.name) return this.$toast('请输入姓名')
            if (!/^1\d{10}$/.test(this.form.phone)) return this.$toast('请输入正确的手机号')
            if (!/^\d{4}$/.test(this.form.code)) return this.$toast('请输入 4 位验证码')
            if (!this.salt) await this.getSalt()
            this.submitting = true
            const res = await noLoginApi.Api_nologinLoginSelfRegisterUserPost({
                app_id: this.appId,
                computer_code: this.computerCode(),
                salt: this.salt,
                avatar: '',
                name: this.form.name,
                sex: this.form.sex,
                phone_number: this.form.phone,
                code: this.form.code
            })
            this.submitting = false
            if (res && res.errcode === 0) {
                this.$toast.success('注册并绑定成功')
                finishWechatAuth(this.$router)
            } else {
                this.getSalt()
            }
        }
    }
}
</script>

<style scoped>
.auth_page { min-height: 100%; overflow-y: auto; background: #f5f8f7; color: #1f2937; }
.auth_header { display: flex; min-height: 250px; padding: 50px 38px 94px; align-items: flex-start; gap: 24px; color: #fff; background: linear-gradient(145deg, #316fe5, #4e89ff 68%, #6b9dff); }
.auth_header button { display: grid; flex: 0 0 62px; width: 62px; height: 62px; place-items: center; border: 0; border-radius: 50%; color: #fff; background: rgba(255,255,255,.14); font-size: 30px; }
.auth_header p { margin-top: 4px; color: rgba(255,255,255,.7); font-size: 18px; font-weight: 700; letter-spacing: 2px; }
.auth_header h1 { margin-top: 8px; font-size: 40px; }
.auth_card { position: relative; z-index: 2; margin: -58px 28px 40px; padding: 34px 30px; border: 1px solid #e8edf2; border-radius: 28px; background: #fff; box-shadow: 0 14px 38px rgba(31,41,55,.1); }
.intro { margin-bottom: 24px; color: #7c8798; font-size: 23px; line-height: 1.6; }
.auth_card ::v-deep .van-cell { min-height: 94px; margin-bottom: 18px; align-items: center; border-radius: 18px; background: #f7f9fc; font-size: 26px; }
.auth_card ::v-deep .van-field__label { width: 96px; color: #52647d; }
.auth_card ::v-deep .van-field__control { min-width: 0; font-size: 23px; }
.code_button { min-width: 142px; min-height: 54px; border: 1px solid #4e89ff; border-radius: 999px; color: #316fe5; background: #fff; font-size: 21px; }
.code_button:disabled { border-color: #d7dce3; color: #a3abb6; }
.primary_button { display: grid; width: 100%; min-height: 88px; margin-top: 30px; place-items: center; border: 0; border-radius: 999px; color: #fff; background: #4e89ff; box-shadow: 0 10px 20px rgba(78,137,255,.24); font-size: 28px; font-weight: 700; }
.primary_button:disabled { opacity: .65; }
.notice { display: flex; margin-top: 28px; padding: 20px; align-items: flex-start; gap: 12px; border-radius: 16px; color: #457158; background: #edf8f0; font-size: 21px; line-height: 1.55; }
.notice .van-icon { flex: 0 0 auto; margin-top: 2px; color: #318b55; font-size: 27px; }
</style>
